import MDB from '../marketingdb'

const getCurrentUser = () => MDB.CurrentUser;

export {
    getCurrentUser
}